import React from "react";
import { legalLinks, offer } from "../data/offer";
export function SiteFooter() {
  const year = new Date().getFullYear();
  return <footer className="bg-navy-deep text-white/70" data-id="element-258" data-mp="3r8rikunn8i0h">
      <div className="mx-auto max-w-6xl px-5 py-10 text-center" data-id="element-259" data-mp="3mh13kbdrh62q">
        <p className="font-display font-bold text-white" data-id="element-260" data-mp="3mfgc4umqu393">
          {offer.productName} — {offer.productSubtitle}
        </p>
        <p className="mt-1 text-sm" data-id="element-261" data-mp="3dgl4rf7yqn47">Digital Christian educational resources for families.</p>

        <nav aria-label="Legal" className="mt-6" data-id="element-262" data-mp="38i1fb4u5ut73">
          <ul className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm" data-id="element-263" data-mp="38g6tlob2ex1y">
            {legalLinks.map(link => {
            const href = link.href || (link.label === "Contact Us" && offer.supportEmail ? `mailto:${offer.supportEmail}` : "");
            return <li key={link.label} data-id="element-264" data-mp="11q0k5wbsg8hv">
                  {href ? <a href={href} className="underline-offset-4 transition-colors duration-150 hover:text-white hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-gold" data-id="element-265" data-mp="wrpabllhtxzn">
                      {link.label}
                    </a> : <span data-id="element-266" data-mp="vus8s1tv0yvy">{link.label}</span>}
                </li>;
          })}
          </ul>
        </nav>

        <p className="mx-auto mt-6 max-w-2xl text-xs leading-relaxed text-white/50" data-id="element-267" data-mp="1ogth1i8y8gjw">
          © {year} {offer.productName}. All rights reserved. This site is not affiliated with Facebook, Instagram, or
          Meta. This is a digital product; no physical items will be shipped.
        </p>
      </div>
    </footer>;
}